const DEFAULT_CHAT_STORAGE_KEY = 'testera_ai_companion_messages';
const LEGACY_COMPANION_STORAGE_PREFIXES = [
  'testera_ai_companion',
  'testera_admin_companion',
];

/** Scope Companion transcripts to tenant+user so switching workspaces never reuses another chat. */
export function companionChatStorageKey({
  mode = 'workspace',
  variant = 'dock',
  tenantId,
  userId,
} = {}) {
  const tid = tenantId != null && String(tenantId).trim() ? String(tenantId).trim() : '';
  const uid = userId != null && String(userId).trim() ? String(userId).trim() : '';
  const scope = tid && uid ? `${tid}:${uid}` : (tid || uid || 'anon');
  if (mode === 'admin') return `testera_admin_companion_messages:${scope}`;
  if (variant === 'onboarding') return `testera_ai_companion_onboarding:${scope}`;
  return `testera_ai_companion_messages:${scope}`;
}

/** Clear all Companion session transcripts (call on logout / account switch). */
export function clearCompanionChatStorage() {
  try {
    const keys = [];
    for (let i = 0; i < sessionStorage.length; i += 1) {
      const k = sessionStorage.key(i);
      if (!k) continue;
      if (LEGACY_COMPANION_STORAGE_PREFIXES.some((p) => k === p || k.startsWith(`${p}_`) || k.startsWith(`${p}:`))) {
        keys.push(k);
      }
    }
    keys.push(
      DEFAULT_CHAT_STORAGE_KEY,
      'testera_ai_companion_onboarding',
      'testera_admin_companion_messages',
    );
    [...new Set(keys)].forEach((k) => {
      try { sessionStorage.removeItem(k); } catch { /* ignore */ }
    });
  } catch { /* ignore */ }
}

/** One-shot: drop unscoped legacy keys so they cannot leak across tenants. */
export function purgeLegacyCompanionChatStorage() {
  try {
    [
      DEFAULT_CHAT_STORAGE_KEY,
      'testera_ai_companion_onboarding',
      'testera_admin_companion_messages',
    ].forEach((k) => {
      try { sessionStorage.removeItem(k); } catch { /* ignore */ }
    });
  } catch { /* ignore */ }
}
